class FilterSort extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      container: 'filter-sort',
      form: '[js-filter-form]',
      filter: '[js-filter]',
      clearAll: '[js-clear-all]'
    }

    this._events = {
      change: "filter:change"
    }

    this._cache = [];

    this._debouncedOnSubmit = this._debounce((event) => {
      this._onSubmitHandler(event);
    }, 500);
  }

  connectedCallback() {
      this._form = this.querySelector(this._selectors.form);
      this._clearAll = this.querySelectorAll(this._selectors.clearAll);
      // this._loader = this.querySelector(this._selectors.loader);
      this._setListeners()
  }

  _setListeners() {
    window.addEventListener('popstate', this._onHistoryChange);
    this._form.addEventListener('input', this._debouncedOnSubmit);
    if (this._clearAll) {
      this._clearAll.forEach(clear => {
        clear.addEventListener('click', this._onClearAllHandler);
      })
    }
    document.addEventListener('filter:clearAll', this._onClearAllHandler);
  }

  _renderComponent(parsedHTML) {
    const containers = parsedHTML.querySelectorAll(this._selectors.container);
    var selector = '';
    containers.forEach(container => {
      if (container.dataset.tab == 'filter') {
        selector = '[js-filter-container]'
      } else{
        selector = '[js-sort-container]'
      }
    })
    const scopedHTML = parsedHTML.querySelector(selector);
    this._refreshElements([this._selectors.filter], scopedHTML, this);
    document.querySelectorAll('s-collection-grid').forEach(grid => {
      document.body.addEventListener('click', grid._drawerClose, true);
    });
  }

  _onSubmitHandler = evt => {
    evt.preventDefault();
    const formData = new FormData(this._form);
    const searchParams = new URLSearchParams(formData).toString();

    const pathName = window.location.pathname;
    let prevParams = `${window.location.search}`.toString().replace('?','&');

    window.sessionStorage.setItem('prevParams', prevParams);
    window.sessionStorage.setItem('searchParams', searchParams);

    // Clear session storage variables when using Filter-Sort on a new page
    if (!window.sessionStorage.getItem('pathName')) {
      window.sessionStorage.setItem('pathName', pathName);
    } else {
      if (window.sessionStorage.getItem('pathName') !== pathName) {
        window.sessionStorage.removeItem('prevParams');
        window.sessionStorage.removeItem('searchParams');
        window.sessionStorage.removeItem('filters');
        window.sessionStorage.removeItem('sort');
        window.sessionStorage.setItem('pathName', pathName);
      }
    }

    if (searchParams.includes('filter')) {
      let filters = searchParams.split('&');
      if (filters.length > 1) {
        let allFilters = ''
        filters.forEach((filter, i) => {
          allFilters += (i > 0 ? '&' + filter : filter)
        })
        window.sessionStorage.setItem('filters', allFilters)
      } else {
        window.sessionStorage.setItem('filters', filters)
      }
    } else{
      window.sessionStorage.removeItem('filters');

    }

    let sortBy = ''
    if (searchParams.includes('sort_by=')) {
      if (searchParams.includes('&')) {
        sortBy = searchParams.split('&')[1];
      } else {
        sortBy = searchParams
      }
      window.sessionStorage.setItem('sort', '&' + sortBy)
      window.sessionStorage.setItem('prevParams', (prevParams) + '&' + sortBy)
    }

    let newParams = window.sessionStorage.getItem('filters') + (window.sessionStorage.getItem('sort') ? window.sessionStorage.getItem('sort') : '') + (searchParams.includes('&filter.v.availability=1') ? '' : '&filter.v.availability=1');
    this._propagateChange(newParams);
  }

  _onClearAllHandler = evt => {
    window.sessionStorage.removeItem('filters');
    window.sessionStorage.removeItem('sort');
    this.querySelectorAll('s-accordion').forEach(accordion => {
      accordion.connectedCallback();
    });
    document.querySelectorAll('s-collection-grid').forEach(grid => {
      document.body.addEventListener('click', grid._drawerClose, true);
    });
    evt.preventDefault();
    const searchParams = '';
    this._propagateChange(searchParams);
  }

  _onHistoryChange = evt => {
    const searchParams = evt.state ? evt.state.searchParams : FilterSort.searchParamsInitial;
    if (searchParams === FilterSort.searchParamsPrev) return;
    this._propagateChange(searchParams, false)
    // change didn't come from submit, so reset field
    this._onSubmitHandlerEvent = null; 
  }

  async _propagateChange(searchParams, updateURLHash = true) {
    // this._loader.setAttribute('loading', '');
    if (!searchParams.includes('filter.v.availability=1')){
      searchParams += '&filter.v.availability=1';
    }
    if (searchParams == 'filter.v.availability=1' || searchParams == '&filter.v.availability=1'){
      searchParams = '';
    }
    const url = `${window.location.pathname}?${searchParams}`
    const filterDataUrl = element => element.url === url;
    const parsedHTML = this._cache.some(filterDataUrl) ? this._markupFromCache(filterDataUrl) : (await this._markupFromFetch(url));
    document.dispatchEvent(new CustomEvent('filter:change', {
      detail: { parsedHTML }
    }))
    this._renderComponent(parsedHTML) // re-render myself
    this.querySelectorAll('s-accordion').forEach(accordion => {
      accordion.connectedCallback();
    });
    document.querySelectorAll('s-collection-grid').forEach(grid => {
      document.body.addEventListener('click', grid._drawerClose, true);
    });
    if (updateURLHash){
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);      
    };
    // this._loader.removeAttribute('loading', '');

  }

  _markupFromCache(url) {
    const html = this._cache.find(url).html;
    return new DOMParser().parseFromString(html, 'text/html')
  }

  _markupFromFetch(url) {
    let cache = this._cache
    return fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        cache = [...cache, { html, url }];
        return parsedHTML;
      });
  }

  _debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  _refreshElements(selectors, newHTML, container) {
    selectors.forEach(selector => {
      const newEls = newHTML.querySelectorAll(selector)
      const oldEls = container.querySelectorAll(selector)
      oldEls.forEach((oldEl, idx) => {
        if (newEls[idx]){
          if (oldEl.getAttribute('js-accordion-item') != null) {
            const oldHeaderStatus = oldEl.querySelector('[js-accordion-header]').getAttribute('aria-expanded')
            const oldContentStatus = oldEl.querySelector('[js-accordion-content]').getAttribute('aria-hidden')
            const newEl = newEls[idx]
            newEl.querySelector('[js-accordion-header]').setAttribute('aria-expanded', oldHeaderStatus);
            newEl.querySelector('[js-accordion-content]').setAttribute('aria-hidden', oldContentStatus);
            oldEl.innerHTML = newEl.innerHTML
          } else {
            oldEl.innerHTML = newEls[idx].innerHTML
          }
        } else {
          oldEl.remove();
        }
      })
    })
  }

}
// Class variables
FilterSort.searchParamsInitial = window.location.search.slice(1);
FilterSort.searchParamsPrev = window.location.search.slice(1);
customElements.define('filter-sort', FilterSort);


class CollectionGrid extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      productGrid: '[js-products-grid]',
      filterDrawer: '[js-filter-drawer]',
      filterOpen: '[js-filter-open]',
      filterClose: '[js-filter-close]',
      detailsButton: "[open-details-drawer]"
    }

    this._refresh = [
      '[js-products-grid]'
    ]

    // cache fetches for performance
    this._cache = []
  }

  connectedCallback() {
      this.filterDrawer = this.querySelector(this._selectors.filterDrawer);
      this.filterOpen = this.querySelectorAll(this._selectors.filterOpen);
      this.filterClose = this.querySelectorAll(this._selectors.filterClose);
      this.detailButtons = this.querySelectorAll(this._selectors.detailsButton);
      this.detailButtons.forEach(button => {
        button.addEventListener("click", this._detailsDrawer)
      })
      this._setListeners();

  }

  _setListeners() {
    document.addEventListener('filter:change', this._handleFilterChange);
    this.filterOpen.forEach(button => {
     button.addEventListener('click', this._openFilter);
    })
  }

  _openFilter = () => {
    this.filterClose.forEach(close => {
      close.addEventListener('click', this._closeFilter);
    })
    this.filterDrawer.style.transform = "translateX(0)"
    var main = document.querySelector('#main');
    var button = document.querySelector('[aria-label="Open Form"]')
    if (button) button.style.zIndex = "-1";
    main.classList.add('js-drawer-open')
    main.classList.remove('overflow-hidden')
    document.body.classList.add('js-drawer-open')
    document.body.classList.add('overflow-hidden')
    setTimeout(() => {
      document.body.addEventListener('click', this._drawerClose, true);
    }, 500);
  }

  _closeFilter = (evt) => {
    if (evt) evt.preventDefault();
    var main = document.querySelector('#main');
    this.filterDrawer.style.transform = "translateX(200%)"
    var button = document.querySelector('[aria-label="Open Form"]')
    if (button) button.style.zIndex = "99999";
    main.classList.remove('js-drawer-open')
    main.classList.add('overflow-hidden')
    document.body.classList.remove('js-drawer-open')
    document.body.classList.remove('overflow-hidden')
    document.body.removeEventListener('click', this._drawerClose, true);

  }

  _drawerClose = (evt) => {
    var main = document.querySelector('#main');
    if (!this.filterDrawer.contains(evt.target) && main.classList.contains('js-drawer-open')){
      this._closeFilter();
    }
    document.body.removeEventListener('click', this._drawerClose, true);
  }


  _handleFilterChange = (evt) => {
    const { parsedHTML } = evt.detail;
    const scopedHTML = parsedHTML.querySelector(`[data-id="${this.dataset.id}"]`)
    this._refreshElements(this._refresh, scopedHTML, this);
  }

  _refreshElements(selectors, newHTML, container) {
    selectors.forEach(selector => {
      const newEls = newHTML.querySelectorAll(selector)
      const oldEls = container.querySelectorAll(selector)
      oldEls.forEach((oldEl, idx) => {
        if (newEls[idx]){
          oldEl.innerHTML = newEls[idx].innerHTML
        } else {
          oldEl.remove();
        }
      })
    })
  }
}

customElements.define('s-collection-grid', CollectionGrid);


class ActiveFilters extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      remove: '[js-remove]',
      clearAll: '[js-clear-all]'
    }

    this._refresh = [
      '[js-active-filter]'
    ]
  }

  connectedCallback() {
      document.addEventListener('filter:change', this._handleFilterChange);
      this._setListeners();
  }

  _setListeners() {
    const clearAll = this.querySelector(this._selectors.clearAll);
    if (clearAll) {
      clearAll.addEventListener('click', this._triggerClearAll);
    }
    
    this.querySelectorAll(this._selectors.remove).forEach(remove => remove.addEventListener('click', this._handleRemove))
  } 

  _handleRemove = (evt) => {
    evt.preventDefault();
    const { name, value } = evt.currentTarget.dataset;
    const input = document.querySelector(`filter-sort [name="${name}"][value="${value}"]`);
    if (input) input.click();
  }

  _handleFilterChange = (evt) => {
    const { parsedHTML } = evt.detail;
    const scopedHTML = parsedHTML.querySelector('active-filters')
    this.innerHTML = scopedHTML.innerHTML;
    this._setListeners();
  }

  _triggerClearAll = (evt) => {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    document.dispatchEvent(new CustomEvent('filter:clearAll'))
  }
}
customElements.define("active-filters", ActiveFilters);

/**
  * Accordion Component
  * --------------------------------------------------------------------
  * @summary accordion component, hides/shows elements based on header button click, auto-collapses sibling accordions by default
  *
  * @usage
  *   <s-accordion data-manual-collapse="false" js-accordion>
  *      <div class="accordion-item" js-accordion-item>
  *        <button class="accordion-header" aria-expanded="true" aria-controls="accordionID" js-accordion-header>Description</button>
  *        <div id="accordionID" class="accordion-content" aria-hidden="false" js-accordion-content>
  *          ...
  *        </div>
  *      </div>
  *    </s-accordion>
  *
  * The following parameters are attributes that the <s-accordion> element takes
  * @param data-manual-collapse - set attribute to "true" to disable auto-collapse siblings
  * @param data-manual-children - set attribute to "false" to disable auto-collapsing children accordions
  *
  * The following are selectors that the <s-accordion> searches for
  * [js-accordion] - required
  * [js-accordion-item] - required
  * [js-accordion-header] - required
  * [js-accordion-content] - required
  * [data-manual-collapse] - optional
  * 
  * .accordion-content[aria-hidden="false"] - this styling can be adjusted based on content + desired animation
*/

class Accordion extends HTMLElement {
  constructor() {
    super();   

    this._selectors = {
      accordion: '[js-accordion]',
      accordionItem: '[js-accordion-item]',
      accordionHeader: '[js-accordion-header]',
      accordionContent: '[js-accordion-content]'
    }
  }

  connectedCallback(){
    this.buttons = this.querySelectorAll(this._selectors.accordionHeader);
    this.buttons.forEach(button => {
      button.addEventListener('click', this._toggleContent)
    })

    this.content = this.querySelectorAll(this._selectors.accordionContent);
  }

  _toggleContent = (e) => {
    e.stopImmediatePropagation();
    e.preventDefault();
    const trigger = e.currentTarget;
    const content = this.querySelector(`#${trigger.getAttribute('aria-controls')}`);
    const siblings = this._getSiblings(trigger.parentElement, this._selectors.accordionItem)
    let isExpanded = trigger.getAttribute('aria-expanded');
    if (isExpanded == 'false') {
      trigger.setAttribute('aria-expanded', true);
      this._prepareTransition(content);
      this._expandSection(content);

      if (!this.dataset.manualCollapse) {
        siblings.forEach((sibling) => {
          const siblingTrigger = sibling.querySelector(this._selectors.accordionHeader);
          const siblingContent = sibling.querySelector(`#${siblingTrigger.getAttribute('aria-controls')}`);
          if (siblingTrigger.getAttribute('aria-expanded') == 'true') {
            siblingTrigger.setAttribute('aria-expanded', false);
            this._collapseSection(siblingContent)
          }
        })
      }
    }else{
      trigger.setAttribute('aria-expanded', false);
      this._collapseSection(content);
    }
  }

  _collapseSection(element) {
    // mark the section as "currently hidden"
    element.setAttribute('aria-hidden', true);
  }

  _expandSection(element) {
    // mark the section as "currently not hidden"
    element.setAttribute('aria-hidden', false);
  }

  _getSiblings(element, selector) {
    let siblings = [];
    let targets;
    
    if (selector) {
      targets = element.parentNode.querySelectorAll(':scope > ' + selector)
    } else {
      targets = element.parentNode.children;
    }

    
    for (let target of targets) {
      if (target !== element)
        siblings.push(target);
    }

    return siblings;
  }

  _prepareTransition(element) {
    element.addEventListener('transitionend', () => {
      element.classList.remove('is-transitioning');
    })
  
    // check the various CSS properties to see if a duration has been set
    var cl = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"];
    let duration = 0;
    const computedStyles = getComputedStyle(element)
    cl.forEach((prop) => duration || (duration = parseFloat(computedStyles.getPropertyValue(prop))));
  
    // if I have a duration then add the class
    if (duration != 0) {
      element.classList.add('is-transitioning');
      element.offsetWidth; // check offsetWidth to force the style rendering
    }
  }
}
customElements.define("s-accordion", Accordion);

/**
 * <s-tabs>
 *   <div class="tab__triggers" role="tablist" aria-orientation="horizontal" js-tablist>
 *     <button id="tab1-tab" class="tab__trigger" aria-controls="tab1-content-panel" role="tab" aria-selected="true" js-tab>Tab1</button>
 *     <button id="tab2-tab" class="tab__trigger" aria-controls="tab2-content-panel" role="tab" aria-selected="false" js-tab>Tab2</button>
 *     <button id="tab3-tab" class="tab__trigger" aria-controls="tab3-content-panel" role="tab" aria-selected="false" js-tab>Tab3</button>
 *   </div>
 *   <div id="tab1-content-panel" class="tab__panel" role="tabpanel" aria-labelledby="tab1-tab" aria-hidden="false"></div>
 *   <div id="tab2-content-panel" class="tab__panel" role="tabpanel" aria-labelledby="tab2-tab" aria-hidden="true"></div>
 *   <div id="tab3-content-panel" class="tab__panel" role="tabpanel" aria-labelledby="tab3-tab" aria-hidden="true"></div>
 * </s-tabs>
 **/

class Tabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
      this._elements = {
        tabs: this.querySelectorAll('[js-tab]'),
        tabList: this.querySelectorAll('[js-tab-list]'),
        tabPanel: this.querySelectorAll('[js-tab-panel]')
      };

      this._tabEventListener();
      this._tabListListener();
  }


  _tabEventListener = () => {
    const { tabs } = this._elements;
    tabs.forEach((tab) =>
      tab.addEventListener("click", this._showTabPanel)
    );
  }

  _showTabPanel = (el) => {
    const { tabs } = this._elements;
    for (let i = 0; i < tabs.length; i++) {
      tabs[i].setAttribute('aria-selected', 'false');
    }
    el.target.setAttribute('aria-selected', 'true');
    var tabPanelToOpen = el.target.getAttribute('aria-controls');
    var tabPanels = document.querySelectorAll('[role=tabpanel]');
    for (let i = 0; i < tabPanels.length; i++) {
      tabPanels[i].setAttribute('aria-hidden', 'true');
    }
    document.getElementById(tabPanelToOpen).setAttribute('aria-hidden', 'false');
  }

  _tabListListener = () => {
    const { tabList } = this._elements;
    tabList.forEach((list) =>
      list.addEventListener("keydown", this._tabListKeydown)
    );
  }

  _tabListKeydown = (e) => {
    if (e.keyCode == 37) {
      $("[aria-selected=true]").prev().click().focus();
      e.preventDefault();
    }
    if (e.keyCode == 38) {
      $("[aria-selected=true]").prev().click().focus();
      e.preventDefault();
    }
    if (e.keyCode == 39) {
      $("[aria-selected=true]").next().click().focus();
      e.preventDefault();
    }
    if (e.keyCode == 40) {
      $("[aria-selected=true]").next().click().focus();
      e.preventDefault();
    }
  }

}
customElements.define("s-tabs", Tabs);

